module.exports = __webpack_public_path__ + "img/img3.68f9429e.jpg";